import { z } from 'zod';

export const emailInboxAttachmentSchema = z.object({
  id: z.string(),
  name: z.string(),
  contentType: z.string(),
  size: z.number(),
  contentBase64: z.string().optional(),
});

export type EmailInboxAttachment = z.infer<typeof emailInboxAttachmentSchema>;

export const emailInboxTagsSchema = z.object({
  isVerification: z.boolean(),
  hasMagicLinks: z.boolean(),
  hasAttachments: z.boolean(),
});

export type EmailInboxTags = z.infer<typeof emailInboxTagsSchema>;

export const emailInboxMessageSchema = z.object({
  id: z.string(),
  content: z.string(),
  subject: z.string().optional(),
  from: z.string().optional(),
  receivedAt: z.string(),
  tags: emailInboxTagsSchema.optional(),
  attachments: z.array(emailInboxAttachmentSchema).optional(),
  rawPlain: z.string().optional(),
  rawHtml: z.string().optional(),
  links: z.array(z.string()).optional(),
});

export type EmailInboxMessage = z.infer<typeof emailInboxMessageSchema>;

export const emailInboxPayloadSchema = z.object({
  emailAddress: z.string().optional(),
  messages: z.array(emailInboxMessageSchema),
});

export type EmailInboxPayload = z.infer<typeof emailInboxPayloadSchema>;

export function parseEmailInboxPayload(
  output: unknown,
): EmailInboxPayload | undefined {
  const candidate = normalizeOutput(output);

  if (candidate === undefined) {
    return undefined;
  }

  const parsed = emailInboxPayloadSchema.safeParse(candidate);

  return parsed.success ? parsed.data : undefined;
}

function normalizeOutput(output: unknown): unknown {
  if (typeof output !== 'string') {
    return output;
  }

  const trimmed = output.trim();

  if (!trimmed) {
    return undefined;
  }

  try {
    return JSON.parse(trimmed);
  } catch {
    return undefined;
  }
}
